import React from "react";
import { useSelector, useDispatch } from "react-redux";
import classNames from "classnames";

import {
  makeStyles,
  Card,
  CardContent,
  CardMedia,
  Typography,
  IconButton
} from "@material-ui/core";
import { Cancel, CheckCircle } from "@material-ui/icons";
import blue from "@material-ui/core/colors/blue";
import green from "@material-ui/core/colors/green";

import { removeCreative, selectCreative } from "../../../actions/app/creatives";

import defaultImagePath from "../../../utils/defaultImages/defaultCreative.jpg";
import { ROTATION_TYPES } from "../../../actions/app/constants";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundSize: "contain"
  },
  card: {
    width: "90%",
    float: "right",
    marginBottom: 16,
    position: "relative",
    display: "flex"
  },
  thumb: {
    width: 250,
    margin: 4
  },
  selected: {
    border: `2px solid ${blue[500]}`,
    backgroundColor: blue[50]
  },
  details: {
    textAlign: "left",
    width: "80%",
    paddingRight: "45px"
  },
  icon: {
    position: "absolute",
    right: 0
  },
  name: {
    wordBreak: "break-all"
  },
  fileName: {
    paddingBottom: theme.spacing(1),
    wordBreak: "break-all"
  },
  taxonomy: {
    wordBreak: "break-all",
    paddingBottom: theme.spacing(1),
    fontWeight: 500
  },
  thumbCard: {
    width: 250,
    margin: "1.5%",
    position: "relative"
  },
  pointer: {
    cursor: "pointer"
  }
}));

const renderRotationData = (index, asset, rotationType) => {
  switch (rotationType) {
    case ROTATION_TYPES.WEIGHTED:
      return `Weight: ${asset.weight}`;
    case ROTATION_TYPES.SEQUENTIAL:
      return `Sequence: ${index + 1}`;
    default:
      return;
  }
};

const HorizontalAssetBackupPreview = ({
  id,
  asset,
  index,
  isClickEnabled,
  isDragDisabled,
  isCardSelected,
  handleSelectedCard,
  isThumbnailEnabled
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  let selectedId = useSelector(state => state.creatives.selectedId);
  const rotationType = useSelector(state => state.creatives.rotationType);
  let isSelected = isCardSelected || asset.id === selectedId;

  const handleClick = () => {
    if (isSelected) {
      dispatch(selectCreative(""));
    } else {
      dispatch(selectCreative(asset.id));
    }
    handleSelectedCard(asset.id);
  };

  const cardStyles = classNames({
    [classes.card]: true,
    [classes.pointer]: isClickEnabled,
    [classes.selected]: isSelected && isClickEnabled
  });

  return (
    <Card className={cardStyles} onClick={isClickEnabled ? handleClick : null}>
      <CardMedia
        className={classes.thumb}
        image={asset.preview ? asset.preview : defaultImagePath}
        title={asset.file.name}
        key={asset.id}
        classes={{ root: classes.root }}
      />
      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            className={classes.taxonomy}
          >
            {asset.taxonomy.name ? `Creative name: ${asset.taxonomy.name}` : ""}
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            className={classes.name}
          >
            BACKUP
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            className={classes.fileName}
          >
            File name: {asset.file.name}
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            className={classes.name}
          >
            Dimensions:{" "}
            {asset.dcmCreative
              ? `${asset.dcmCreative.size.width} x ${asset.dcmCreative.size.height}`
              : asset.dimensions}
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            className={classes.name}
          >
            {asset.creativeRole === "PRIMARY"
              ? renderRotationData(index, asset, rotationType)
              : null}
          </Typography>
        </CardContent>
      </div>
      {asset.taxonomy.name && asset.taxonomy.urlId ? (
        <IconButton className={classes.icon} disabled={true}>
          <CheckCircle style={{ color: green[500] }} />
        </IconButton>
      ) : (
        <IconButton
          className={classes.icon}
          onClick={e => {
            e.stopPropagation();
            dispatch(removeCreative(asset.id));
          }}
        >
          <Cancel filled="true" color="action" />
        </IconButton>
      )}
    </Card>
  );
};

HorizontalAssetBackupPreview.defaultProps = {
  isCardSelected: false,
  handleSelectedCard: () => {}
};

export default HorizontalAssetBackupPreview;
